import React from 'react';
import { Col, ModalV2, Row, Spinner2, Text } from 'components';
import { Avatar } from 'components/Tailwindcss';
import { theme } from 'lib';
import { VoteItem } from '../styles';

const VotesModal = ({ visible, onClose, votesList, loadingVotes }) => {
  return (
    <ModalV2
      visible={visible}
      closeModal={onClose}
      width="500px"
      header={
        <Row start centerAll>
          <Text h3 bold>
            Votes List
          </Text>
          {votesList.length > 0 && (
            <Text b2 med col={theme.GREY_60} marg="0 0 0 12px">
              ({votesList.length})
            </Text>
          )}
        </Row>
      }
    >
      <Col pad="0" ht="400px" start style={{ overflowY: 'auto' }}>
        {loadingVotes ? (
          <Col center pad="40px 0">
            <Spinner2 />
          </Col>
        ) : votesList.length === 0 ? (
          <Col center pad="40px 0">
            <Text center b2 col={theme.GREY_60}>
              No votes yet
            </Text>
          </Col>
        ) : (
          votesList.map((user) => (
            <VoteItem key={user._id}>
              <Avatar src={user.avatar} size={40}>
                {user.name}
              </Avatar>
              <Col gap="2px">
                <Text b1 bold>
                  {user.name || user.username}
                </Text>
                {user.username && (
                  <Text c2 col={theme.GREY_60}>
                    @{user.username}
                  </Text>
                )}
              </Col>
            </VoteItem>
          ))
        )}
      </Col>
    </ModalV2>
  );
};

export default VotesModal;
